export class SpendAccount {
  id: number;
  contract_id: number;
  name: string | null;
  balance: number;
  is_active: boolean;

  constructor(data: any) {
    this.id = data.id;
    this.contract_id = data.contract_id;
    this.name = data.name ?? null;
    this.balance = Number(data.balance ?? 0);
    this.is_active = data.is_active ?? true;
  }
}
